import { useMediaQuery } from '@material-ui/core';
import React, { useState } from 'react';
import { MUI_MOBILE_BREAKPOINT } from 'src/scripts/utils/constants';
import { IStoreAvailabilityData } from './FindInStore';

const FindInStoreTile = ({
  store,
  displayMode = 'inline',
  openModal,
}: {
  store: IStoreAvailabilityData;
  displayMode: 'inline' | 'modal';
  openModal?: () => void;
}) => {
  const [showDetails, setShowDetails] = useState(false);
  const toggleDetails = () => {
    setShowDetails((prevShowDetails) => !prevShowDetails);
  };
  const isMobile = useMediaQuery(MUI_MOBILE_BREAKPOINT, { noSsr: true });

  function trimNumbersFromString(name: string) {
    const trimmedString = name.replace(/\d+/g, '');
    return trimmedString.trim();
  }

  return (
    <div className="find-in-store-tile d-flex">
      <div className="find-in-store-tile__first d-flex">
        <div className="find-in-store-tile__column">
          {store.name && <p className="black-text">{trimNumbersFromString(store.name)}</p>}
          <div className="stock-indicator d-flex">
            <div
              className={
                store.available_after_safety_stock > 0 ? 'stock-indicator__available' : 'stock-indicator__unavailable'
              }
            ></div>
            <p className="stock-indicator__text">
              {store.available_after_safety_stock > 0 ? 'In Stock' : 'Out of Stock'}
            </p>
          </div>
        </div>
        {displayMode === 'modal' ? (
          isMobile ? (
            <button className="accordion-icon" onClick={toggleDetails}>
              {showDetails ? <span className="alo-subtract-icon"></span> : <span className="alo-add-icon"></span>}
            </button>
          ) : null
        ) : (
          <button className="details-link" onClick={openModal}>
            Details
          </button>
        )}
      </div>
      {store.address && displayMode === 'modal' && (
        <div className={`find-in-store-tile__row ${isMobile && showDetails ? '' : 'hide'}`}>
          <span className="alo-location-pin-icon"></span>
          <div>
            <p>{store.address.address1 && store.address.address1}</p>
            <p>{store.address.address2 && store.address.address2}</p>
            <p>
              {store.address.city && <span>{store.address.city}</span>}
              {store.address.province_code && <span>, {store.address.province_code}</span>}
              {store.address.postal_code && <span> {store.address.postal_code}</span>}
            </p>
          </div>
        </div>
      )}
      {store.hours_of_operation.length > 0 && displayMode === 'modal' ? (
        <div className={`find-in-store-tile__row ${isMobile && showDetails ? '' : 'hide'}`}>
          <span className="alo-clock-icon"></span>
          <div>
            {store.hours_of_operation.map((row, index) => {
              return (
                <div className="find-in-store-hours d-flex" key={index}>
                  <p className="find-in-store-hours__row">{row.day_text}:</p>
                  <p className="find-in-store-hours__row">{row.hour_text}</p>
                </div>
              );
            })}
          </div>
        </div>
      ) : // empty flex div for desktop modal when there are no store hours to display
      displayMode === 'modal' && !isMobile ? (
        <div className="find-in-store-tile__row"> </div>
      ) : null}
    </div>
  );
};

export default FindInStoreTile;
